import React, { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardUpsellBadge = (props: Props) => {
  const { variant = 'default', children } = props;

  const { match } = useResponsive();

  const containerBottomPadding = match([
    styles.containerBottomPaddingXS,
    styles.containerBottomPaddingSM,
  ]);

  const containerStyle = [
    styles.container,
    variant === 'bottom' ? styles.containerBottom : undefined,
    variant === 'bottom' ? containerBottomPadding : undefined,
  ];

  const textStyle = [styles.text, variant === 'bottom' ? styles.textBottom : undefined];
  const textSizeLg = variant === 'bottom' ? ('14' as const) : ('16' as const);

  return (
    <Animated.View
      entering={FadeIn.duration(theme.transitions.short)}
      exiting={FadeOut.duration(theme.transitions.short)}
      style={containerStyle}
      pointerEvents="none"
    >
      <BodyText sizeMatch={['12', '12', textSizeLg]} style={textStyle} pointerEvents="auto">
        {children}
      </BodyText>
    </Animated.View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    alignSelf: 'center',
    backgroundColor: theme.colors.OATMEAL,
    borderRadius: theme.radius.medium,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['2'],
  },
  containerBottom: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 0,
    borderBottomLeftRadius: theme.radius.large,
    borderBottomRightRadius: theme.radius.large,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  containerBottomPaddingXS: {
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['2'],
  },
  containerBottomPaddingSM: {
    paddingVertical: 5,
  },
  text: {
    color: theme.colors.DARK_KALE,
  },
  textBottom: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  variant?: 'default' | 'bottom';
}>;
